<template>
  <div>
    <p class="text-center card-text">{{dev.devcName}}</p>
    <canvas :id="canId"></canvas>
    <p class="text-right card-text">{{device.recentSeries ? recentSeries.datetime : ''}}</p>
  </div>
</template>

<script>
import { RadialGauge } from 'canvas-gauges';
import SeriesSvc from '@/services/SeriesSvc';
import { formatNum } from '@/util/number';

export default {
  name: 'SpeedMeter',
  props: ['type', 'canId', 'dev', 'data'],
  data() {
    return {
      device: {},
      recentSeries: {},
      speedMeter: null,
    };
  },
  methods: {
    dateRange(date) {
      this.$emit('dateRange', date);
    },
    async getData(devcUniqueId) {
      if (devcUniqueId) {
        const filter = {
          start: 1593561600,
          end: parseInt(formatNum((new Date().getTime() / 1000), 0)),
        };
        const resp = await SeriesSvc.getWeeklySeries(filter, devcUniqueId);
        const range = {
          from: resp.data.data.fromString,
          to: resp.data.data.toString,
        };
        this.dateRange(range);
        this.onFinishedGetData(resp.data.data);
        let log = resp.data.data.devices.map((v) => {
          const data = {};
          data.device = this.dev;
          data.devcType = v;
          data.series = resp.data.data.series.filter((o) => o.deviceId === v);
          data.series = data.series.map((s) => {
            s.data = JSON.parse(s.data);
            return s;
          });
          data.recentSeries = data.series[0];
          return data;
        });
        log = log.find((o) => o.devcType === devcUniqueId);
        this.device = log;
        this.recentSeries = resp.data.data.series[0];
        this.generateWidget(log);
      }
    },
    generateWidget(log) {
      this.speedMeter = new RadialGauge({
        renderTo: this.canId,
        units: 'RPM',
        animateOnInit: true,
        animatedValue: true,
        minValue: 0,
        maxValue: 180,
        majorTicks: [
          '0',
          '20',
          '40',
          '60',
          '80',
          '100',
          '120',
          '140',
          '160',
          '180',
        ],
        minorTicks: 2,
        strokeTicks: true,
        highlights: [
          {
            from: 80,
            to: 120,
            color: 'rgba(238, 238, 0, 1)',
          },
          {
            from: 120,
            to: 180,
            color: 'rgba(200, 50, 50, .75)',
          },
        ],
        colorPlate: '#fff',
        borderShadowWidth: 0,
        borders: false,
        needleType: 'arrow',
        needleWidth: 2,
        needleCircleSize: 7,
        needleCircleOuter: true,
        needleCircleInner: false,
        animationDuration: 1500,
        animationRule: 'linear',
        value: log.recentSeries.data.rpm,
      }).draw();
    },
    onFinishedGetData(series) {
      const fields = [
        { key: 'datetime', label: 'Date', class: 'text-center' },
        { key: 'data.rpm', label: 'Speed (RPM)', class: 'text-center' },
      ];
      const logs = series.series.map((s) => {
        const log = {};
        log.datetime = s.datetime;
        log.id = s.id;
        log.data = JSON.parse(s.data);
        return log;
      });
      this.$emit('collectedData', logs);
      this.$emit('fieldsData', fields);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(devcUniqueId) {
        this.getData(devcUniqueId);
      },
    },
  },
};
</script>

<style scoped>

</style>
